import { render } from "./singlenews.vue?vue&type=template&id=36654ab3&scoped=true"
import script from "./singlenews.vue?vue&type=script&lang=js"
export * from "./singlenews.vue?vue&type=script&lang=js"

import "./singlenews.vue?vue&type=style&index=0&id=36654ab3&lang=css"
import "./singlenews.vue?vue&type=style&index=1&id=36654ab3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36654ab3"]])

export default __exports__